import React from 'react';
import './index.less';
/**
 * Lack of better name resulted in PageContainer.
 * This is a general purpose wrapper for content you wish to put on your page.
 * It adds necessary background color, padding, margin and width adjustments
 * */
var PageContainer = function (_a) {
    var children = _a.children;
    return (React.createElement("article", { className: "genericpagecontainer" }, children));
};
export default PageContainer;
